import React, { memo } from 'react';
import { View, FlatList } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';
import { PreviewLinkItem } from '@redlink/components/molecules';

export const PreviewResumeLinks = memo(({ title, data = {}, style }) => {
  const { styles } = useStyle();
  return (
    <>
      {data.length > 0 && (
        <View style={style}>
          <Text style={styles.text}>{title}</Text>
          <FlatList
            {...{ data }}
            contentContainerStyle={styles.groupContainer}
            ItemSeparatorComponent={() => <Space size={8} />}
            renderItem={({ item: { logoName, title, shortLinkUrl } }) => (
              <PreviewLinkItem
                {...{ logoName, title }}
                externalUrl={shortLinkUrl}
              />
            )}
            showsVerticalScrollIndicator={false}
          />
        </View>
      )}
    </>
  );
});

const useStyle = createUseStyle(({ colors }) => ({
  container: {
    marginBottom: 24,
    marginHorizontal: 24,
  },
  text: {
    fontSize: 16,
    color: colors.title,
    fontWeight: 'bold',
    marginBottom: 8,
  },
}));
